import type { IconProps } from '../types/IconProps.ts';
export const Save: IconProps = {
    name: 'Save',
    children: [
        `<path d="M3 5c0-1.1.9-2 2-2h9.17a2 2 0 0 1 1.42.59L20.4 8.4a2 2 0 0 1 .6 1.43V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />`,
        `<path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7M7 3v4a1 1 0 0 0 1 1h6" />`,
    ]
};